type IdeaMeta = {
  format_template?: string;
  length_tag?: string;
  tone_style?: any;
  keywords?: string[];
  section_layout?: string[];
  element_settings?: Record<string, any>;
  content_type?: string;
};

type PrepareArgs = {
  title: string;
  websiteId: string;
  language: string;
  currentWebsiteUrl?: string | null;
  websiteInfo?: any;
  keyContentPages?: any[];
  scrapedContent?: any[];
  ideaMeta?: IdeaMeta;
};

export function prepareV3OnboardingRequest({
  title,
  websiteId,
  language,
  currentWebsiteUrl,
  websiteInfo,
  keyContentPages,
  scrapedContent,
  ideaMeta
}: PrepareArgs) {
  const websiteInfoUrl = (websiteInfo?.website_url || websiteInfo?.url || websiteInfo?.website?.url) as string | undefined;
  const website_url = (currentWebsiteUrl || websiteInfoUrl || localStorage.getItem('onboardingWebsite') || '').toString();

  const toObj = (p: any) => ({
    title: p?.title || '',
    url: p?.url || p?.original_url || p?.link || '',
    content: p?.content || '',
    digest: p?.digest || ''
  });

  const cornerstone_content = Array.isArray(keyContentPages) ? keyContentPages.map(toObj) : [];
  const scraped_content = Array.isArray(scrapedContent) ? scrapedContent.map(toObj) : [];

  const format_template = ideaMeta?.format_template || 'guide';
  const content_type = ideaMeta?.content_type || 'post';
  const length_tag = ideaMeta?.length_tag || 'medium';
  const tone_style = ideaMeta?.tone_style || {};
  const keywords = Array.isArray(ideaMeta?.keywords) ? ideaMeta!.keywords! : [];

  return {
    title,
    website_id: websiteId,
    is_onboarding: true,
    website_url,
    format_template,
    length_tag,
    tone_style,
    content_type,
    keywords,
    // Let server defaults compute section layout/element settings if missing
    // section_layout: ideaMeta?.section_layout,
    // element_settings: ideaMeta?.element_settings,
    language,
    cornerstone_content,
    scraped_content,
    postThemeId: '',
    passedWebsiteId: websiteId
  };
}



